'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002425 from "./presto.-Agent-View$$anon$25.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002427 from "./presto.-Agent-View$$anon$27.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-File-Base64-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$24() {
  this.axy = null;
  this.axq = null;
  this.axr = false;
  this.axz = null;
  this.axA = false;
  this.axD = null;
  this.axw = null;
  this.axx = false;
  this.axs = null;
  this.axt = false;
  this.axu = null;
  this.axv = false;
  this.axB = false;
  this.axC = false;
  this.axy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axD = "LocalPjeOfficeSignFileBase64Request";
}
export { $c_Lpresto_AgentView$$anon$24 as $c_Lpresto_AgentView$$anon$24 };
$p = $c_Lpresto_AgentView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$24;
/** @constructor */
function $h_Lpresto_AgentView$$anon$24() {
}
export { $h_Lpresto_AgentView$$anon$24 as $h_Lpresto_AgentView$$anon$24 };
$h_Lpresto_AgentView$$anon$24.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.axy;
});
$p.M = (function() {
  if ((!this.axr)) {
    this.axq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axr = true;
  }
  return this.axq;
});
$p.O = (function() {
  if ((!this.axA)) {
    this.axz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axA = true;
  }
  return this.axz;
});
$p.E = (function() {
  return this.axD;
});
$p.t = (function() {
  if ((!this.axx)) {
    this.axw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("files", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axx = true;
  }
  return this.axw;
});
$p.N = (function() {
  if ((!this.axt)) {
    this.axs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002425.$c_Lpresto_AgentView$$anon$25())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axt = true;
  }
  return this.axs;
});
$p.Q = (function() {
  if ((!this.axv)) {
    this.axu = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002427.$c_Lpresto_AgentView$$anon$27();
    this.axv = true;
  }
  return this.axu;
});
$p.v = (function() {
  if ((!this.axC)) {
    this.axB = false;
    this.axC = true;
  }
  return this.axB;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee180) => ((p) => \u03b4scrutinee180.cFj(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dFile$002dBase64$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignFileBase64Request$())));
});
var $d_Lpresto_AgentView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$24, "presto.AgentView$$anon$24", ({
  DL: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$24 as $d_Lpresto_AgentView$$anon$24 };
//# sourceMappingURL=presto.-Agent-View$$anon$24.js.map
